import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { APPLICATION_PATHS, ENTITLEMENTS } from '../application-core/constants';
import OntologyManagerIcon from '../core/icons/OntologyManager';
import ProjectsManager from '../core/project/ProjectsManager';
import ProjectWrapper from '../core/project/ProjectWrapper';
import StandardAppBar from '../core/StandardAppBar';
import CreateOntologyProject from './ontologyproject/CreateOntologyProject';
import OntologyProject from './ontologyproject/OntologyProject';
import OntologyProjectsManager from './OntologyProjectsManager';

class OntologyApplication extends Component {

  render() {

    return (
      <React.Fragment>
        <Switch>
          <Route exact path={APPLICATION_PATHS.ONTOLOGY_MANAGER} render={
            (props) => <ProjectsManager {...props}
              appBar={<StandardAppBar title="Ontology Manager" />}
              projectCreator={CreateOntologyProject}
              projectType="OntologyProject"
              lockedGraphs={this.props.lockedGraphs}
              entitlement={ENTITLEMENTS.CREATE_ONTOLOGY_PROJECT}
              homeIcon={{
                name: "Ontology Manager Home",
                url: '',
                icon: <OntologyManagerIcon/>
              }}
              projectClass="https://grafsync.graphifi.com/schema/gs/OntologyProject"
              applicationTitle="Ontology Manager"
              applicationURL={APPLICATION_PATHS.ONTOLOGY_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.ONTOLOGY_MANAGER + "/project"} render={
            (props) => <ProjectWrapper {...props}
              component={OntologyProject}
              lockedGraphs={this.props.lockedGraphs}
              applicationTitle="Ontology Manager"
              applicationURL={APPLICATION_PATHS.ONTOLOGY_MANAGER}
            />
          } />
          <Route path={APPLICATION_PATHS.ONTOLOGY_MANAGER} render={
            (props) => <OntologyProjectsManager {...props}
              applicationTitle="Ontology Manager"
              applicationURL={APPLICATION_PATHS.ONTOLOGY_MANAGER}
            />
          } />
        </Switch>
      </React.Fragment>
    );
  }
}

OntologyApplication.propTypes = {
  lockedGraphs: PropTypes.array
};

export default OntologyApplication;